import styled from 'styled-components';

export const Card = styled.div`
  display: flex;
  background-color: rgba(128, 128, 128, 0.3);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: background-color 0.2s;
  height: 80px;

  &:hover {
    background-color: rgba(128, 128, 128, 0.5);
  }

  ${(props) =>
    props.selected &&
    `
    background-color: rgba(128, 128, 128, 0.5);
  `}
`;

export const ThumbnailContainer = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
  flex-shrink: 0;
  background-color: #000;
`;

export const Thumbnail = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ModalityBadge = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: #3498db;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 1;
`;

export const InfoContainer = styled.div`
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Description = styled.p`
  margin: 4px 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Details = styled.div`
  display: flex;
  gap: 8px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
`;
